export default __webpack_public_path__ + "static/media/onboarding-info-2.b0eb8b8d.jpeg";